/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Cognos Analytics Home
 *| (C) Copyright IBM Corp. 2020, 2021
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
define({
	homePageTitleLabel: 'Home',
	myContent: 'Mijn content',
	teamContent: 'Teaminhoud',
	folder: 'Map',
	files: 'Bestanden',
	actionMenu: 'Actiemenu\n',
	myFolder: 'Persoonlijke mappen',

	emptyFolderNoContent: 'Geen inhoud',

	//EmptyStates
	emptyRecentTitle: 'U hebt de laatste tijd geen content bekeken.',
	emptyStateTitle: 'Begin met het toevoegen van gegevens',
	emptyStateBody: 'Klik hierboven op gegevens uploaden of versleep gegevens om ze te uploaden.',
	emptySearchResultTitle: 'Uw zoekopdracht heeft geen resultaat opgeleverd.',
	emptyPortalTitle: 'Geen portals',
	emptyPortalBody: 'U hebt momenteel geen portals.',
	emptyWsProjectTitle: 'Begin met het maken van een notebook in Watson Studio.',
	emptyWsProjectBody: 'Als u terugkeert naar Cognos Analytics ziet u uw notebook hier.',
	emptyFilteredResultTitle: 'De toegepaste filters hebben geen resultaat opgeleverd.',
	emptyDialogViewTitle: 'Geen items',
	removeFromRecents: 'Verwijderen uit recent\n',

	// Welcome Banner
	welcomeBannerGreeting: 'Hallo. Welkom bij Cognos Analytics.',
	welcomeBannerDescription: 'Cognos Analytics geeft gebruikers de beschikking over AI-gestuurde zelfservice analytics. Bekijk hoe geautomatiseerde voorbereiding van gegevens, gegevensverkenning en visualisatie helpen meer betrouwbare beslissingen te maken.',
	welcomeBannerDescription_trialUser: 'U kunt direct aan de slag gaan door onze introductievideo, de productrondleiding en het tabblad Aan de slag te bekijken. ',
	takeTourButtonLabel: 'Productrondleiding volgen',
	watchVideoButtonLabel: 'Video bekijken',
	// confirmation dialog
	hideWelcomeBannerMsg: 'Weet u zeker dat u de welkomstbanner op de homepage wilt uitzetten? U kunt dit weer aanzetten in Profiel  en instellingen > Instellingen > Algemeen. ',
	hideWelcomeBannerTitle: 'Welkomstbanner uitzetten',
	ok: 'OK',
	cancel: 'Annuleren',
	//howto video dialog
	modal_how_title: 'Instructievideo\'s',
	modal_overview_title: 'Overzicht van Cognos Analytics bekijken',
	modal_how_play: 'Video afspelen\n',
	modal_how_video_title_overview: 'Overzicht',
	modal_how_video_title_getStarted: 'Aan de slag in 11.2',
	modal_how_video_title_newUI: 'Welkom bij de nieuwe Cognos-ervaring',
	modal_how_video_title_dataModule: 'Overzicht van gegevensmodules',
	modal_how_video_title_explore: 'Overzicht van gegevensverkenning',
	modal_how_video_title_dashboard: 'Overzicht van interactieve dashboards',
	modal_how_video_title_reporting: 'Overzicht van rapportage',
	modal_how_video_title_mobile: 'De kracht van Cognos in uw handpalm',

	// Toolbar
	search: 'Zoeken',
	addFolder: 'Map toevoegen',
	addLink: 'Koppeling toevoegen',
	filter: 'Filteren',
	sort: 'Sorteren',
	settings: 'Instellingen',
	tilesView: 'Tegelview',
	listView: 'Lijstview',
	columnView: 'Kolomview',

	// Toolbar Actions
	sortBy: 'Sorteren op',
	sortOrder: 'Volgorde',
	name: 'Name',
	modifiedTime: 'Gewijzigd',
	type: 'Typen',
	ascending: 'Oplopend',
	descending: 'Aflopend',

	filterType: 'Typen',
	filterModificationTime: 'Gewijzigd',
	all: 'Alle',
	today: 'Vandaag',
	yesterday: 'Gisteren',
	pastWeek: 'Vorige week',
	pastMonth: 'Vorige maand',
	resetFilters: 'Filters opnieuw instellen\n',

	filterSearchPlaceHolder: 'Filteren op trefwoorden',

	resetFilterTag: 'Klik op X om filters te resetten.',
	filterTagToolTip: 'Toegepaste filters: %{appliedFilters}.',

	folderName: 'Mapnaam',
	addAFolder: 'Map toevoegen',
	add: 'Toevoegen',
	error: 'Fout',
	newFolderDefaultName: 'Nieuwe map',
	toastCreateNewFolder: 'Map %{nameOfFolder} is gemaakt in %{tabName}.',
	folderAdded: 'Map toegevoegd',
	refresh: 'Vernieuwen',
	openFolder: 'Map openen',

	addAUrl: 'URL toevoegen',
	linkName: 'URL-naam',
	linkNamePlaceholder: 'URL-naam toevoegen',
	linkDescription: 'Beschrijving (optioneel)\n',
	linkDescriptionPlaceholder: 'Geef een beschrijving op\n',
	linkUri: 'URL',
	linkUriPlaceholder: 'Voeg een URL toe met een aanvaardbaar domein',
	acceptableDomains: 'Aanvaardbare domeinen',
	viewAcceptableDomains: 'Aanvaardbare domeinen bekijken',
	mandatoryField: 'Verplicht veld',
	linkAdded: 'URL toegevoegd',
	toastCreateNewLink: '%{nameOfLink} is toegevoegd aan %{tabName}.',
	noEntries: 'Er zijn geen items in de lijst met aanvaardbare domeinen. Neem contact op met de beheerder.',

	compact: 'Compact',
	short: 'Kort',
	default: 'Standaardwaarde',
	rowSize: 'Rijgrootte',

	// GroupyByTypes
	folders: 'Mappen',
	reports: 'Rapporten',
	dashboards: 'Dashboards',
	data: 'Gegevens',
	packages: 'Pakketten',
	explorations: 'Verkenningen',
	stories: 'Story\'s',
	notebooks: 'Notebooks',
	others: 'Overige',

	// Error Messages
	itemsOverLimit: 'De opgegeven naam "%{itemName}" is langer dan toegestaan (20 tekens). Geef een andere naam op om door te gaan.',
	errorMessageLengthFolderName: 'Geef een mapnaam op die niet langer is dan 255 tekens.',
	errorMessageLengthLinkName: 'Geef de naam van een koppeling op die niet langer is dan 255 tekens.',
	toastLaunchPerspectiveError: '%{objectType} kan niet geopend worden.',
	errorNoAccessTitle: 'Het lijkt erop dat u geen toegang tot deze inhoud hebt.',
	errorNoAccessBody: 'Neem contact op met de beheerder of gebruik de volgende link:',
	errorEnableExternalContent: 'Externe inhoud inschakelen',

	//TableHeader
	lastModified: 'Laatst gewijzigd',
	location: 'Locatie',
	tenant: 'Tenant',

	// GetStartedTab
	getStartedLabel: 'Aan de slag in IBM Cognos Analytics',
	learningHowToLabel: 'Studieresources',
	learningHowToDescription: 'Breid uw kennis uit en krijg hulp door te zoeken in de community, documentatie te lezen en video\'s te bekijken.',
	learningHowToActionLabel: 'Studiepagina starten',
	howToVideosLabel: 'Instructievideo\'s',
	howToVideosDescription: 'Zie hoe u IBM Cognos Analytics kunt gebruiken om inzicht te krijgen in uw data.',
	howToVideosActionLabel: 'Video\'s bekijken',
	acceleratorCatalogLabel: 'Accelerator-catalogus',
	acceleratorCatalogDescription: 'Blader door een groeiende catalogus van industrieel gebruik, handleidingen met best practices, aangepaste visualisaties en meer.',
	acceleratorCatalogActionLabel: 'Bladeren in catalogus',
	sampleSectionTitle: 'Voorbeelden',
	sampleSectionDescription: 'Experimenteer met voorbeelden die laten zien wat Cognos Analytics te bieden heeft.',
	// Samples Section
	createDashboardSampleTitle: 'Hoe u uw eerste dashboard maakt',
	createDashboardSampleDescription: 'Begin uw werkzaamheden in analytics met Cognos-dashboards.',
	covid19SampleTitle: 'COVID-dashboard',
	covid19SampleDescription: 'Verken de mogelijkheden met dit Cognos-dashboard waarin u aan COVID-19 gerelateerde gegevens en aangepaste extensies analyseert.',
	sankeySampleTitle: 'Sankey',
	sankeySampleDescription: 'Breid uw visualisatiebibliotheek uit met aangepaste visualisaties zoals het Sankey-diagram.',
	viewAllSamplesActionLabel: 'Alle voorbeelden bekijken',
	byFeatureTitle: 'Per functie',
	byFeatureDescription: 'Blader door voorbeelden per functie, zoals kernfunctionaliteit, aangepaste besturing, uitbreidingen, notebooks en relatieve datums. ',
	byIndustryTitle: 'Per sector',
	byIndustryDescription: 'Blader door voorbeelden per sector, bijvoorbeeld automotive, banking en andere.',
	// SamplesTab
	sampleTabTitle: 'Laat u inspireren door onze voorbeelden',
	sampleTabLabel: 'Bekijk de Accelerator Catalog voor meer voorbeelden en uitbreidingen van IBM, partners en klanten',

	// quickLaunch
	quickLaunchLabel: 'Snel starten\n',
	expand: 'Uitvouwen',
	collapse: 'Samenvouwen',

	// quickLaunch dialog
	quickLaunchModalLabel: 'Begin door te kiezen wat u wilt maken.',

	// contentPageView
	contentPageTitleLabel: 'Inhoud',
	uploadFile: 'Gegevens uploaden',
	new: 'Nieuw',
	create: 'Maken',
	more: 'Meer',

	// open dialog
	selectDataSourcesToAdd: 'Selecteer de gegevensbron(nen) die u wilt toevoegen.',
	openDialogDefaultTitle: 'Openen',

	// save dialog
	save: 'Opslaan',
	saveAs: 'Opslaan als',
	saving: 'Opslaan...',
	selectedDestination: 'Geselecteerde bestemming: %{nameOfFolder}',
	toastDuplicateFileDifferentType: '\'%{nameOfItem}\' bestaat al met een ander type. Kies een andere naam.',
	confirmOverwriteTitle: 'Bevestig de vervanging van bestaande gegevens',
	confirmOverwriteMsg: 'Het bestand \'%{nameOfFile}\' bestaat al. Wilt u de gegevens ervan vervangen door de gegevens uit het geselecteerde bestand?',

	// copy move dialog
	copy: 'Kopiëren',
	move: 'Verplaatsen',
	copyOrMove: 'Kopiëren of verplaatsen: ',
	copyOnly: 'Kopiëren',
	createShortcut: 'Snelkoppeling maken',
	createShortcutDialogTitle: 'Snelkoppeling maken:',

	// External asset types
	wsProject: 'Watson Studio-project',
	externalContentTypeWs: 'Watson Studio',

	// Asset Types
	package: 'Pakket',
	dataModule: 'Gegevensmodule',
	exploration: 'Verkenning',
	mode: 'Modus',
	live: 'Live',
	snapshot: 'Momentopname',
	noSnapshotsFound: 'Geen momentopname gevonden\n',
	uploadedFile: 'Geüpload bestand\n',
	fileUpload: 'Gegevens uploaden',
	dataSetEx: 'Gegevensset',
	externalRepository: 'Externe repository',
	queryMode: 'Querymodus',
	queryModeCompatible: 'Compatibel',
	queryModeDynamic: 'Dynamisch',
	report: 'Rapport',
	activeReport: 'Actief rapport',
	query: 'Query',
	analysis: 'Analyse',
	dashboard: 'Dashboard',
	dashboardTemplate: 'Dashboardsjabloon\n',
	jupyterNotebook: 'Notebook',
	wsNotebook: 'Watson Studio-notebook',
	jupyter: 'Jupyter',
	ws: 'Watson Studio',
	story: 'Story',
	workspace: 'Werkgebied',
	pagelet: 'Pagina',
	content: 'Inhoud',
	directory: 'Naamruimten',
	dataSet: 'Gegevensset',
	powerPlayCube: 'PowerPlay-kubus\n',
	powerPlayReport: 'PowerPlay-rapport',
	powerPlay8Report: 'PowerPlay-rapport',
	powerPlay8ReportView: 'PowerPlay-rapportview',
	reportTemplate: 'Rapportsjabloon',
	packageConfigurations: 'Pakketconfiguratie',
	agent: 'Agent',
	agentDefinition: 'Agentdefinitie',
	agentDefinitionView: 'Agentview',
	dataMovementTask: 'Gegevensverplaatsingstaak',
	dataMovementTaskAlias: 'Alias van gegevensverplaatsingstaak',
	document: 'Document',
	DocumentRetention: 'Documenteigenschappen',
	jobDefinition: 'Taakdefinitie',
	job: 'Taak',
	metricsDataSourceETLTask: 'ETL-taak van metricgegevensbron',
	metricsExportTask: 'Exporttaak metrics\n',
	metricsFileImportTask: 'Importtaak metricsbestand',
	metricsMaintenanceTask: 'Onderhoudstaak metrics\n',
	planningTask: 'Planningstaak',
	shortcut: 'Snelkoppeling',
	URL: 'URL',
	launchable: 'Startbaar',
	dataSetFolder: 'Map van gegevensset',
	ViewAccessibleLabel: '%{label} bekijken',
	overrideReportOptions: 'De standaard rapportopties overschrijven',
	formats: 'Indelingen',
	saveReport: 'Het rapport opslaan',
	promptForValues: 'Aan mij vragen\n',
	reportView: 'Rapportview',
	html: 'html',
	pdf: 'pdf',
	spreadsheetML: 'Excel',
	xlsxData: 'Excel-gegevens',
	csv: 'csv',
	xml: 'xml',
	txt: 'txt',
	//Details
	details: 'Details',
	open: 'Openen',
	created: 'Gemaakt',
	modified: 'Gewijzigd',
	owner: 'Eigenaar',
	dataSource: 'Gegevensbron',
	share: 'Delen',
	addToFavorites: 'Aan favorieten toevoegen',
	properties: 'Eigenschappen',
	detailsEmptyStateBody: 'Selecteer een item om de details ervan te bekijken',
	editNameAndDescription: 'Geef de naam en beschrijving op',
	none: 'Geen',

	//rename dialog
	nameInvalid: 'Naam is ongeldig',
	namePlaceholder: 'Geef een naam op',
	description: 'Naam',
	descriptionInvalid: 'De beschrijving mag niet langer zijn dan 350 tekens.',
	descriptionPlaceholder: 'Geef een beschrijving op',
	errorMessageApostropheError: 'Voer een bestandsnaam in die niet zowel een \' als een " bevat',
	renameCollisionError: '%{name} bestaat al. Voer een andere naam in.\n',
	unknownRenameError: 'Hernoemen van item is mislukt. Neem voor hulp contact op met de beheerder.\n',

	//types
	xls: 'xls',
	xlsx: 'xlsx',

	unableToOpenFolderMsg: 'De opgegeven map kan niet worden geopend.',

	//Upload
	uploadToFolder: "Uploaden naar <span class=\"homeUploadFolder\">\"<span id=\"homeUploadFolderName\">%{folderName}</span>\"</span>%{launchAction}",
	uploadAndLaunch: "Uploaden naar <span class=\"homeUploadFolder\">\"<span id=\"homeUploadFolderName\">%{folderName}</span>\"</span> en %{launchAction} starten",
	quickUpload: "Snelle upload",
	quickUploadAndLaunch: "Versleep bestanden om ze te uploaden naar <span class=\"homeUploadFolder\">\"<span id=\"homeUploadFolderName\">%{folderName}</span>\"</span> en ze in een van de volgende ruimten te openen.",
	unsupportedFilesSingle: "%{files} is niet geüpload omdat dit bestand ongeldig is voor Snel starten.",
	unsupportedFilesMultiple: "De bestanden zijn niet geüpload, want de bestanden die u selecteert, moeten geldig zijn voor Snel starten.\n",
	unsupportedFilesSingleInvalid: "%{files} is ongeldig.",
	unsupportedFilesMultipleInvalid: "%{files} zijn ongeldig.",
	supportedFileTypes: "Alleen de volgende bestandstypen zijn toegestaan: %{extensions}.",
	uploadDragAndDrop: "Slepen en neerzetten",
	uploadDragAndDropMessage: "Versleep uw bestand hiernaartoe om het naar <span class=\"homeUploadFolder\">\"<span id=\"homeUploadFolderName\">%{folderName}</span>\"</span> te uploaden",

	// searchBar
	searchWasSaved: 'Zoekcriteria \'%{searchTerm}\' opgeslagen.',
	searchWasntSaved: 'Zoekcriteria \'%{searchTerm}\' niet opgeslagen.',
	searchSuggestions: 'Suggesties',
	savedSearch: 'Opgeslagen zoekopdrachten',
	searchWasDeleted: 'Zoekcriteria \'%{searchTerm}\' gewist.',
	searchWasntDeleted: 'Zoekcriteria \'%{searchTerm}\' niet gewist.',
	savedBarTitle: 'Zoeken in Cognos Analytics',
	searchContentPageTitle: 'Zoeken',
	searchContentPageTitleLabel: 'Resultaten worden afgebeeld voor \'%{searchTerm}\'',
	showingSearchRsult: 'Er worden %{resultCount} items afgebeeld',
	saveSearch: 'Zoekactie opslaan',
	saveTenSearches: 'U kunt 10 zoekopdrachten opslaan.\n',
	deleteASearch: 'Wis er een om een andere op te slaan.',
	close: 'Sluiting',

	//recent view
	recents: 'Recent',
	noAccessRecent: 'Geen toegang\n',
	noAccessRecentMsg: 'U hebt geen toegang tot deze asset. Mogelijk is hij uitgeschakeld of gewist, of zijn uw machtigingen ervoor ingetrokken. Controleer de status van de asset op de verwachte bronlocatie ervan. U kunt de asset uit uw recente items verwijderen door op OK te klikken.\n',
	noAccessMsg: 'U hebt geen toegang tot deze asset. Mogelijk is hij uitgeschakeld of gewist, of zijn uw machtigingen ervoor ingetrokken. ',

	//contextToolbar
	itemsSelected: '%{nameOfSelection} items geselecteerd',
	itemSelected: '%{nameOfSelection} item geselecteerd'

});